module.exports = __webpack_public_path__ + "assets/img/advertisement.4d791945.jpg";